import React, { useState } from "react";
import { styled } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import MenuApp from "./menu-app";

import { Typography, Container, Breadcrumbs } from "@mui/material";

import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import WorkingTime from "./workingTime";
import Attendance from "./attendance";

const StyledRoot = styled("div")({
  backgroundColor: "#FFFFFF !important",
});

const ManagerReportCenter = () => {
  const { t } = useTranslation();
  const [view, setView] = useState(null);
  const [open, setOpen] = useState(false);
  const [breadcrumbs, setBreadcrumbs] = useState([]);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <StyledRoot className="page">
      <Container maxWidth="lg" style={{ paddingTop: "24px", paddingBottom: "24px" }}>
        <div style={{ marginBottom: 8 }}>
          <Typography variant="h4" style={{ paddingTop: 8 }}>
            {t("ReportCenter")}
          </Typography>
        </div>
        <div style={{ marginTop: 16 }}>
          <Breadcrumbs
            separator={<NavigateNextIcon fontSize="small" />}
            aria-label="breadcrumb"
          >
            {breadcrumbs}
          </Breadcrumbs>
        </div>

        <MenuApp setView={setView} handleOpen={handleOpen} />

        {view === "reportWorkingTime" && (
          <WorkingTime open={open} handleClose={handleClose} />
        )}
        {view === "ReportAttendance" && (
          <Attendance open={open} handleClose={handleClose} />
        )}
      </Container>
    </StyledRoot>
  );
};

export default ManagerReportCenter;
